module.exports = __webpack_public_path__ + "assets/certificate_pdf/Java Language Today_Silicon Stone Education_20180911.587797fa.pdf";